import { Icon } from '@buggy/shared'
import { Flex } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import useFormatPrice from '@/hooks/use-format-price'
import { useIntl } from '@/i18n/hooks/use-intl'
import type { CollaborativeItem } from '@/types/schema/collaborative/collaborative-item'
import { convertPlatformShortcode } from '@/utils/convert-platform'
import getCooperationItemI18nKey from '@/utils/get-collaborative-item-i18n-key'

interface CollaborativeItemListProps {
  items: CollaborativeItem[]
}

const CollaborativeItemList: FunctionComponent<CollaborativeItemListProps> = ({
  items,
}) => {
  const { formatMessage, formatNumber } = useIntl()
  const { formatPrice } = useFormatPrice()

  return (
    <Flex gap={12} wrap='wrap'>
      {items.map((item, index) => {
        const platformIconName = item.is_custom_platform
          ? undefined
          : convertPlatformShortcode(item.platform_name).sharedIconName
        const collaborativeItem = item.is_custom_collaborative_item
          ? item.collaborative_item
          : formatMessage({
              id: getCooperationItemI18nKey(item.collaborative_item),
            })
        return (
          <Flex
            align='center'
            gap={8}
            key={`${item.platform_name}-${item.collaborative_item}-${index}`}
          >
            {platformIconName ? (
              <Icon fontSize={14} name={platformIconName} />
            ) : (
              <Text>{item.platform_name}</Text>
            )}
            <Text>
              {formatMessage(
                { id: 'general:collaborative_item' },
                {
                  type: collaborativeItem,
                  count: formatNumber(item.collaborative_items_count),
                  fee: formatPrice(item.cooperation_fee),
                },
              )}
            </Text>
          </Flex>
        )
      })}
    </Flex>
  )
}

const Text = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
`

export default CollaborativeItemList
